<template>
  <div>
    <div class="computedValue">实测最大值：{{maxValue}} - 实测最小值：{{minValue}} - 实测平均值：{{avgValue}}</div>
    <div id="eoc-record-chart" style="width: 100%;height:600px;"></div>
  </div>
</template>
<script>
// Author YuJiaBei
// Date 2021-07-16 15:49:35

import emCommonListMixin from "@/mixin/em/common/list";
import emApiMixin from "@/mixin/em/common/api";
import * as echarts from 'echarts';

export default {
  name: "emOpcComputedRecordLineChart",
  mixins: [emCommonListMixin, emApiMixin],
  props: {
    nodeId: {
      type: String,
      default: "0"
    },
    autoRefresh: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // data: [
      //   {"value":"98","warning":"90","alarm":"100","time":"2021-9-22 21:50"},
      //   {"value":"90","warning":"90","alarm":"100","time":"2021-9-22 21:51"},
      //   {"value":"80","warning":"90","alarm":"100","time":"2021-9-22 21:52"},
      //   {"value":"60","warning":"90","alarm":"100","time":"2021-9-22 21:53"},
      //   {"value":"100","warning":"90","alarm":"100","time":"2021-9-22 21:54"}
      // ],
      data: [],

      //series 的dataset source数据源
      dataTime: [],
      dataValue: [],
      dataWarning: [],
      dataAlarm: [],


      //最大值、最小值
      maxValue:0,
      minValue:0,
      avgValue:0,

      zoomStart: 97,  //初始和x轴初始保持一致
      zoomEnd: 100,

      operation: {},
      myChart: {},
      timer: null,
      timerInterval: 5000,
      dataZoom:[
        {
          type: 'slider',
          xAxisIndex: 0,
          start: 97,
          end: 100,

          //style
          show:true,
          height:'5%',
          bottom:'2%',
          borderColor:'#8FDFFE',
          backgroundColor:'#8fdffe99',

          // //拖拽手柄样式svg路径
          // handleIcon:'M512512m-2080a6.56.501041606.56.5010-4160ZM512192C335.264192192335.264192512c0176.736143.264320320320s320-143.264320-320C832335.264688.736192512192zM512800c-159.0720-288-128.928-288-2880-159.072128.928-288288-288s288128.928288288C800671.072671.072800512800z',
          // handleColor:'#8FDFFE',
          // handleSize:20,
          // handleStyle:{
          //   borderColor:'#8FDFFE',
          //   shadowBlur:4,
          //   shadowOffsetX:1,
          //   shadowOffsetY:1,
          //   shadowColor:'#e5e5e5'
          // },

        },
        // {
        //   type: 'inside',
        //   xAxisIndex: 0,
        //   start: 97,
        //   end: 100
        // },
        {
          type: 'slider',
          yAxisIndex: 0,
          start: 0,
          end: 100
        },
        // {
        //   type: 'inside',
        //   yAxisIndex: 0,
        //   start: 0,
        //   end: 100
        // }
      ]
    }
  },
  computed: {
    modelName() {
      return "emOpcComputedEoc"
    }
  },
  methods: {
    getData() {
      //let _api = this.$_emApiMixin_moduleBaseApi("emOpcComputedEoc") + "/emOpcUaResource/computedRecord"
      //console.log("this is nodeId:" + this.nodeId)
      let _api = this.$_emApiMixin_moduleBaseApi("emOpcComputedEoc") + "/emOpcUaResource/getEmMonitorLineChart"
      this.$_emApiMixin_post(_api, {nodeId: this.nodeId})
          .then((res) => {
            console.log("line chart request")
            console.log(_api)
            this.data = res.data
            //console.log(res.data)

            // -1d 的全局计算，屏蔽不用了
            // let tempMax = 0.0;
            // let tempMin = this.data[0].value;  //第一个值赋值给Min开始循环比对
            // let tempAvg = 0.0;


            this.dataTime = [];
            this.dataValue = [];
            this.dataWarning = [];
            this.dataAlarm = [];

            for(let i in this.data){
              this.dataTime.push(this.data[i].time);
              this.dataValue.push(this.data[i].value);
              this.dataWarning.push(this.data[i].warning);
              this.dataAlarm.push(this.data[i].alarm);

              // -1d 的全局计算，屏蔽不用了
              // //最大值、最小值计算
              // if(parseFloat(this.data[i].value) > tempMax){
              //   tempMax = parseFloat(this.data[i].value);
              // }
              // if(parseFloat(this.data[i].value) < tempMin){
              //   tempMin = parseFloat(this.data[i].value);
              // }
              // tempAvg += parseFloat(this.data[i].value);

            }

            // -1d 的全局计算，屏蔽不用了
            // this.maxValue = tempMax;
            // this.minValue = tempMin;
            // this.avgValue = (tempAvg / this.data.length).toFixed(2);

            //2021.9.24 计算“最大、最小、平均值”
            this.computedMaxMinAvg()


            this.myChart.hideLoading();

            this.myChart.setOption({
              dataset: {
                //source: this.data
                source:
                    {
                      Date: this.dataTime,
                      value: this.dataValue,
                      warning: this.dataWarning,
                      alarm: this.dataAlarm,
                    }
              }
            })
          })
    },
    getDataAndResetDataZoom() {
      //this.$_emApiMixin_moduleBaseApi("emOpcComputedEoc") + "/emOpcUaResource/computedRecord"
      let _api = this.$_emApiMixin_moduleBaseApi("emOpcComputedEoc") + "/emOpcUaResource/getEmMonitorLineChart"
      this.$_emApiMixin_post(_api, {nodeId: this.nodeId})
          .then((res) => {


            this.data = res.data
            //console.log(res.data)

            let tempMax = 0.0;
            let tempMin = this.data[0].value;  //第一个值赋值给Min开始循环比对
            let tempAvg = 0.0;


            this.dataTime = [];
            this.dataValue = [];
            this.dataWarning = [];
            this.dataAlarm = [];

            for(let i in this.data){
              this.dataTime.push(this.data[i].time);
              this.dataValue.push(this.data[i].value);
              this.dataWarning.push(this.data[i].warning);
              this.dataAlarm.push(this.data[i].alarm);

              // -1d 的全局计算，屏蔽不用了
              // //最大值、最小值计算
              // if(parseFloat(this.data[i].value) > tempMax){
              //   tempMax = parseFloat(this.data[i].value);
              // }
              // if(parseFloat(this.data[i].value) < tempMin){
              //   tempMin = parseFloat(this.data[i].value);
              // }
              // tempAvg += parseFloat(this.data[i].value);

            }

            // -1d 的全局计算，屏蔽不用了
            // this.maxValue = tempMax;
            // this.minValue = tempMin;
            // this.avgValue = (tempAvg / this.data.length).toFixed(2);

            //2021.9.24 计算“最大、最小、平均值”
            this.computedMaxMinAvg()


            this.myChart.hideLoading();

            this.myChart.setOption({
              dataset: {
                //source: this.data
                source:
                    {
                      Date: this.dataTime,
                      value: this.dataValue,
                      warning: this.dataWarning,
                      alarm: this.dataAlarm,
                    }
              }
            })
          })
    },
    computedMaxMinAvg(){
      let zoomStart = this.zoomStart;
      let zoomEnd   = this.zoomEnd;

      let s1 = new Date(this.data[0].time);
      let s2 = new Date(this.data[this.data.length - 1].time);

      //console.log(s1);
      //console.log(s2);
      // 计算从后端获取的节点日期"总"间隔秒数(精确到秒吧)
      let totalSeconds = parseInt(parseInt(s2 - s1) / 1000 / 60 * 60);
      //console.log("间隔总秒数：" + totalSeconds);


      // //1.获取当前日期
      // var date=new Date();
      // //2. 获取当前分钟
      // var seconds=date.getSeconds();
      // //3. 设置当前时间+5分钟：把当前分钟数+5后的值重新设置为date对象的分钟数
      // date.setSeconds(seconds + 60 * 60);
      // //4. 测试
      // console.log("计算处理后的日期：" + date.toLocaleString());
      // //5.比较
      // if(s1 > date){
      //   console.log("这个小");
      //   console.log(s1)
      // }

      //计算滑动条移动后的开始和结束事件
      //console.log("后端初始开始时间：" + s1.toLocaleString())
      let newStartTime = new Date(s1.setSeconds(s1.getSeconds() + parseInt(totalSeconds * (zoomStart/100) ) ));
      //console.log(newStartTime.toLocaleString());

      //console.log("后端初始结束时间：" + s2.toLocaleString())
      let newEndTime = new Date(s1.setSeconds(s1.getSeconds() + parseInt(totalSeconds * (zoomEnd/100) ) ));
      //console.log(newEndTime.toLocaleString());

      //前端：循环处理重算滑动后时间间隔内的“最大值、最小值、平均值”
      let tempMax = 0.0;
      let tempMin = 0.0;  //第一个值赋值给Min开始循环比对
      let tempAvg = 0.0;
      let iCount = 0;

      for(let i in this.data){
        let tempTime = new Date(this.data[i].time);

        if(tempTime >= newStartTime && tempTime <= newEndTime){

          if(iCount === 0){
            //第一次比对在范围内的值，赋值给tempMin 用于比较最小值
            tempMin = this.data[i].value;
          }

          // console.log("test round:" + i);
          // console.log(this.data[i].value);
          // console.log(this.data[i].time);
          iCount ++;
          //最大值、最小值计算
          if(parseFloat(this.data[i].value) > tempMax){
            tempMax = parseFloat(this.data[i].value);
          }
          if(parseFloat(this.data[i].value) < tempMin){
            tempMin = parseFloat(this.data[i].value);
          }
          tempAvg += parseFloat(this.data[i].value);
        }
      }

      this.maxValue = tempMax;
      this.minValue = tempMin;
      this.avgValue = (tempAvg / iCount).toFixed(2);
    }
  },
  watch: {
    autoRefresh(newValue) {
      console.log("watch do")
      if (newValue) {
        this.myChart.showLoading();

        //再次弹出时直接刷新，提升加载速度
        //每次新打开窗口，都初始化一下dataZoom
        this.getDataAndResetDataZoom()

        if (this.timer === null) {
          this.timer = setInterval(this.getData, this.timerInterval)
        }
      } else {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  },
  mounted() {
    console.log("mounted do")


    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.getElementById('eoc-record-chart'));
    this.myChart.setOption({
          dataset: {
            // 用 dimensions 指定了维度的顺序。直角坐标系中，
            // 默认把第一个维度映射到 X 轴上，第二个维度映射到 Y 轴上。
            // 如果不指定 dimensions，也可以通过指定 series.encode
            // 完成映射，参见后文。
            // dimensions: ['product', '2015', '2016', '2017'],
            //source: this.data
            source:
                {
                  Date: this.dataTime,
                  value: this.dataValue,
                  warning: this.dataWarning,
                  alarm: this.dataAlarm,
                }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          // 图例组件
          legend: {
            // 当series 有name值时， legend 不需要写data,配合series显示
            // 修改图例组件文字颜色
            textStyle: {
              color: '#4c9bfd'
            },
            right: '10%',
          },
          xAxis: {type: "time"},
          yAxis: {},
          series: [
              //实时数据线
              {
                type: 'line',
                name: '实时数据',
                encode: {
                  // 把 “维度1”映射到 X 轴：
                  x: 0,
                  // 把“维度0”映射到 Y 轴。
                  y: 1
                },
                itemStyle: {
                  color: 'rgb(0, 153, 255)'   //255, 70, 131
                },
                //----------
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgb(204, 255, 255)'   //上面
                  }, {
                    offset: 1,
                    color: 'rgb(153, 255, 102)'  //下面
                  }])
                },
                //-------------
              },
              //警告线
              {
                type: 'line',
                name: '警告',
                showSymbol: false,    //去掉坐标点
                encode: {
                  // 把 “维度1”映射到 X 轴：
                  x: 0,
                  // 把“维度0”映射到 Y 轴。
                  y: 2
                },
                itemStyle: {
                  color: 'rgb(255, 153, 0)'
                },
                //----------区块阴影
                // areaStyle: {
                //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                //     offset: 0,
                //     color: 'rgb(255, 158, 68)'
                //   }, {
                //     offset: 1,
                //     color: 'rgb(255, 70, 131)'
                //   }])
                // },
                //-------------
              },
              //报警线
              {
                type: 'line',
                name: '报警',
                showSymbol: false,
                encode: {
                  // 把 “维度1”映射到 X 轴：
                  x: 0,
                  // 把“维度0”映射到 Y 轴。
                  y: 3
                },
                itemStyle: {
                  color: 'rgb(255, 51, 0)'
                },
                //----------区块阴影
                // areaStyle: {
                //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                //     offset: 0,
                //     color: 'rgb(255, 158, 68)'
                //   }, {
                //     offset: 1,
                //     color: 'rgb(255, 70, 131)'
                //   }])
                // },
                //-------------
              },

          ],
          dataZoom: this.dataZoom
        }
    )


    this.getData()
    this.timer = setInterval(this.getData, this.timerInterval)

    //dataZoom拖动触发事件
    //注意：这里用 function(params){} 函数内部访问this.zoomStart只是函数内部的不是全局的，无法赋值给全局的zoomStart
    //     需要改成箭头函数访问 (params) => {}
    this.myChart.on('dataZoom',(params) => {
      console.log(params);  //里面存有代表滑动条的起始的数字


      //取x轴移动的位置(获取的是0-100的百分比位置)
      this.zoomStart = parseInt(params.start);
      this.zoomEnd = parseInt(params.end);
      //console.log(zoomStart);
      //console.log(zoomEnd);

      // 随着滑动条的拖动，实时计算时间间隔内的“最大值、最小值、平均值”
      this.computedMaxMinAvg();
    })



  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style scoped>
  .computedValue{
    text-align: right;
    padding-right: 11%;
  }
</style>